<template>
  <router-view />
</template>
<script>
  export default {
    name: 'SupervisorModule',
  }
</script>
